import { getAWSSignedURL } from '@app/api/file.api';
import logoImg from '@app/assets/logo.jpg';
import { IDealRoomShare } from '@app/interfaces/deal-room';
import { IUser } from '@app/interfaces/user';
import { getDealRoomBuildingText, getUserFullName } from '@app/utils/utils';
import { isString } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './AgentBannerCard.styles';
import { IClient } from '@app/interfaces/client';

interface AgentBannerCardProps {
  dealRoom: IDealRoomShare;
  homeImg: string;
}

export const AgentBannerCard: React.FC<AgentBannerCardProps> = ({ dealRoom, homeImg }) => {
  const { t } = useTranslation();
  const [imageUrl, setImageUrl] = React.useState<string>(logoImg);
  const responsible = dealRoom?.responsible && dealRoom.responsible ? (dealRoom.responsible as IUser) : null;

  const address = getDealRoomBuildingText(dealRoom);

  React.useEffect(() => {
    async function fetchImage(image: string) {
      try {
        const signedUrl = await getAWSSignedURL(image);
        if (signedUrl) setImageUrl(signedUrl);
      } catch (error) {}
    }

    if (responsible) {
      const image = typeof responsible === 'object' && 'image' in responsible ? responsible.image : null;
      if (image && isString(image)) {
        fetchImage(image);
      }
    }
  }, [responsible]);

  return (
    <S.StyledCard>
      <S.BackgroundWrapper style={{ backgroundImage: `url(${homeImg})` }}>
        <S.ContentWrapper>
          <S.TitleWrapper>
            <S.TitleText>{t('dealRooms.landing.welcome')}</S.TitleText>
            {dealRoom?.client && (dealRoom?.client as IClient)?.id_num && (
              <S.TitleDescription>
                {t('dealRooms.landing.clientId')}: {(dealRoom?.client as IClient)?.id_num}
              </S.TitleDescription>
            )}
            {address && (
              <S.TitleDescription className="mt-2">
                {t('dealRooms.landing.address')}: {address}
              </S.TitleDescription>
            )}
            {dealRoom?.externalDescription && (
              <S.TitleDescription className="mt-2">{dealRoom?.externalDescription}</S.TitleDescription>
            )}
          </S.TitleWrapper>

          <S.AvatarWrapper>
            <S.StyledAvatar size={112} src={imageUrl} />
            <div className="title-section">
              <S.AgentName>{getUserFullName(responsible)}</S.AgentName>
              {responsible?.title && <S.AgentDescription>{responsible.title}</S.AgentDescription>}
            </div>
          </S.AvatarWrapper>
        </S.ContentWrapper>
      </S.BackgroundWrapper>
    </S.StyledCard>
  );
};
